import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // Corrected path and added useNavigate
import { db } from '../firebase/firebaseConfig'; // Corrected path
import {
  collection,
  getDocs,
  doc,
  getDoc,
  updateDoc,
  addDoc,
  deleteDoc, // Add deleteDoc import
} from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

const SyncEditor = () => {
  const { slideshowId } = useParams();
  const navigate = useNavigate(); // Added useNavigate hook
  const [slides, setSlides] = useState([]);
  const [audioUrl, setAudioUrl] = useState(null);
  const [audioDuration, setAudioDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const audioRef = useRef(null);
  const [audioStoragePath, setAudioStoragePath] = useState(null);
const [newAudioFile, setNewAudioFile] = useState(null);
const [uploadingAudio, setUploadingAudio] = useState(false);
const [deletingAudio, setDeletingAudio] = useState(false);

  const [logoSize, setLogoSize] = useState(10);
  const [logoPosition, setLogoPosition] = useState("right");
  const [textAlignment, setTextAlignment] = useState("left");
  const [textBackgroundEnabled, setTextBackgroundEnabled] = useState(false);
  const [textBackgroundColor, setTextBackgroundColor] = useState("#ffffff");
  const [textBackgroundOpacity, setTextBackgroundOpacity] = useState(1); // Default opacity
  const [newLogoUrl, setNewLogoUrl] = useState("");
  const [textSize, setTextSize] = useState(16); // Add state for text size
  const [newSlides, setNewSlides] = useState([]); // Add state for new slides
  const [textColor, setTextColor] = useState("#ffffff"); // Default to white
  const [captionLines, setCaptionLines] = useState([]); // Add state for caption lines
  const [remainingLines, setRemainingLines] = useState(0); // Add state for remaining lines
  const predefinedLogos = [
    { label: "SBL Black Logo", value: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2FSBLLogoBlackTM.png?alt=media&token=2f8fde38-b373-4367-9ade-a7b68bae3b6f" },
    { label: "SBL White Logo", value: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/images%2FSBLLogoWhiteTM.png?alt=media&token=6ef84cf6-6fd9-4b56-bf05-aea9a1784c72" },
  ];

  useEffect(() => {
    const loadData = async () => {
      const slideSnap = await getDocs(collection(db, `slideshows/${slideshowId}/slides`));
      const fetchedSlides = slideSnap.docs.map(doc => ({
        id: doc.id,
        textPosition: doc.data().textPosition || 'bottom', // default to bottom
        ...doc.data()
      }));
      const sortedSlides = fetchedSlides.sort((a, b) => a.order - b.order); // Sort slides by order
      setSlides(sortedSlides);

      const metaSnap = await getDoc(doc(db, `slideshows/${slideshowId}`));
if (metaSnap.exists()) {
  const data = metaSnap.data();
  setAudioUrl(data.audioUrl || null);
  setAudioStoragePath(data.audioStoragePath || null); // <-- add this
  setLogoSize(data.logoSize || 10);
  setLogoPosition(data.logoPosition || "right");
  setTextAlignment(data.textAlignment || "left");
  setTextBackgroundEnabled(data.textBackgroundEnabled || false);
  setTextBackgroundColor(data.textBackgroundColor || "#ffffff");
  setTextBackgroundOpacity(data.textBackgroundOpacity || 1);
  setTextSize(data.textSize || 16);
  setNewLogoUrl(data.logoUrl || "");
  setTextColor(data.textColor || "#ffffff");
}
    };
    loadData();
  }, [slideshowId]);

  useEffect(() => {
    if (audioRef.current) {
      const updateTime = () => {
        if (audioRef.current) { // Add null check
          setCurrentTime(audioRef.current.currentTime);
        }
      };
      const handleLoadedMetadata = () => {
        if (audioRef.current) { // Add null check
          setAudioDuration(audioRef.current.duration);
        }
      };

      audioRef.current.addEventListener('timeupdate', updateTime);
      audioRef.current.addEventListener('loadedmetadata', handleLoadedMetadata);

      return () => {
        if (audioRef.current) { // Add null check
          audioRef.current.removeEventListener('timeupdate', updateTime);
          audioRef.current.removeEventListener('loadedmetadata', handleLoadedMetadata);
        }
      };
    }
  }, [audioUrl]);

  const setTimestampForSlide = (index) => {
    if (!audioRef.current) return;
    const preciseTime = audioRef.current.currentTime;
    const updatedSlides = [...slides];
    updatedSlides[index].timestamp = parseFloat(preciseTime.toFixed(3)); // more precise timestamp
    setSlides(updatedSlides);
  };

  const saveTimestamps = async () => {
    // Save timestamps to Firestore
    for (const slide of slides) {
      if (slide.timestamp !== undefined) {
        const slideRef = doc(db, `slideshows/${slideshowId}/slides/${slide.id}`);
        await updateDoc(slideRef, { timestamp: slide.timestamp });
      }
    }

    // Sort slides by timestamp ascending
    const sortedSlides = [...slides].sort((a, b) => (a.timestamp ?? 0) - (b.timestamp ?? 0));

    // Update order in Firestore and local state
    for (let i = 0; i < sortedSlides.length; i++) {
      const slideRef = doc(db, `slideshows/${slideshowId}/slides/${sortedSlides[i].id}`);
      await updateDoc(slideRef, { order: i + 1 });
      sortedSlides[i].order = i + 1; // Update local order too
    }

    setSlides(sortedSlides); // Update local state to reflect new order
    alert('Timestamps saved and slides reordered!');
  };

  const saveCaptions = async () => {
    for (const slide of slides) {
      const slideRef = doc(db, `slideshows/${slideshowId}/slides/${slide.id}`);
      await updateDoc(slideRef, {
        caption: slide.caption,
        textPosition: slide.textPosition || 'bottom', // Save textPosition
      });
    }
    alert('Captions and text positions saved!');
  };

  const saveMetadata = async () => {
    await updateDoc(doc(db, `slideshows/${slideshowId}`), {
      logoSize,
      logoPosition,
      textAlignment,
      textBackgroundEnabled,
      textBackgroundColor,
      textBackgroundOpacity, // Save text background opacity
      textSize, // Save text size
      logoUrl: newLogoUrl, // Save selected logo URL
      textColor, // Save text color
    });
    alert("Metadata updated!");
  };

  const uploadNewSlides = async () => {
    if (newSlides.length === 0) {
      alert("Please select images to upload.");
      return;
    }

    const storage = getStorage();
    const dbSlidesCollection = collection(db, `slideshows/${slideshowId}/slides`);
    const maxOrder = slides.reduce((max, slide) => Math.max(max, slide.order || 0), 0);

    try {
      let index = 1;
      for (const file of newSlides) {
        const imageRef = ref(storage, `slideshows/${encodeURIComponent(slideshowId)}/images/${encodeURIComponent(file.name)}`);
        await uploadBytes(imageRef, file);
        const url = await getDownloadURL(imageRef);
        const storagePath = imageRef.fullPath;

        await addDoc(dbSlidesCollection, {
          imageUrl: url,
          imageStoragePath: storagePath,
          caption: '',
          order: maxOrder + index,
          timestamp: 0,
        });

        index++;
      }

      alert("New slides uploaded!");
      setNewSlides([]);
      // Reload slides
      const slideSnap = await getDocs(collection(db, `slideshows/${slideshowId}/slides`));
      const fetchedSlides = slideSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const sortedSlides = fetchedSlides.sort((a, b) => a.order - b.order);
      setSlides(sortedSlides);

    } catch (error) {
      console.error("Error uploading new slides:", error);
      alert("Failed to upload new slides.");
    }
  };

  const handleDeleteSlide = async (slideId) => {
    if (!window.confirm("Are you sure you want to delete this slide?")) return;

    try {
      await deleteDoc(doc(db, `slideshows/${slideshowId}/slides/${slideId}`));
      setSlides(prev => prev.filter(slide => slide.id !== slideId));
      alert("Slide deleted.");
    } catch (error) {
      console.error("Error deleting slide:", error);
      alert("Failed to delete slide.");
    }
  };

  const handleDuplicateSlide = async (slide) => {
    const newSlide = {
      imageUrl: slide.imageUrl,
      imageStoragePath: slide.imageStoragePath,
      type: slide.type || 'image',
      caption: slide.caption || '',
      order: slides.length + 1,
      timestamp: 0,
    };

    try {
      await addDoc(collection(db, `slideshows/${slideshowId}/slides`), newSlide);
      const slideSnap = await getDocs(collection(db, `slideshows/${slideshowId}/slides`));
      const fetchedSlides = slideSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const sortedSlides = fetchedSlides.sort((a, b) => a.order - b.order);
      setSlides(sortedSlides);
    } catch (error) {
      console.error("Error duplicating slide:", error);
      alert("Failed to duplicate slide.");
    }
  };

  const moveSlideUp = async (index) => {
    if (index === 0) return; // Already at the top
    const updatedSlides = [...slides];
    [updatedSlides[index - 1], updatedSlides[index]] = [updatedSlides[index], updatedSlides[index - 1]];
    
    // Swap their order numbers
    const tempOrder = updatedSlides[index].order;
    updatedSlides[index].order = updatedSlides[index - 1].order;
    updatedSlides[index - 1].order = tempOrder;

    setSlides(updatedSlides);

    // Update Firestore
    await updateDoc(doc(db, `slideshows/${slideshowId}/slides/${updatedSlides[index].id}`), { order: updatedSlides[index].order });
    await updateDoc(doc(db, `slideshows/${slideshowId}/slides/${updatedSlides[index - 1].id}`), { order: updatedSlides[index - 1].order });
  };

  const moveSlideDown = async (index) => {
    if (index === slides.length - 1) return; // Already at the bottom
    const updatedSlides = [...slides];
    [updatedSlides[index], updatedSlides[index + 1]] = [updatedSlides[index + 1], updatedSlides[index]];

    // Swap their order numbers
    const tempOrder = updatedSlides[index].order;
    updatedSlides[index].order = updatedSlides[index + 1].order;
    updatedSlides[index + 1].order = tempOrder;

    setSlides(updatedSlides);

    // Update Firestore
    await updateDoc(doc(db, `slideshows/${slideshowId}/slides/${updatedSlides[index].id}`), { order: updatedSlides[index].order });
    await updateDoc(doc(db, `slideshows/${slideshowId}/slides/${updatedSlides[index + 1].id}`), { order: updatedSlides[index + 1].order });
  };

  const navButtonStyle = { // Added button styles
    backgroundColor: '#2196F3',
    color: 'white',
    padding: '10px 20px',
    marginRight: '10px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer'
  };

  const applyCaptionsAuto = () => {
    const updatedSlides = [...slides];
    captionLines.forEach((line, index) => {
      if (index < updatedSlides.length) {
        updatedSlides[index].caption = line;
      }
    });
    setSlides(updatedSlides);
  };

  const applyCaptionsSelected = () => {
    const updatedSlides = [...slides];
    let captionIndex = 0;
    updatedSlides.forEach((slide) => {
      if (slide.applyCaption && captionIndex < captionLines.length) {
        slide.caption = captionLines[captionIndex];
        captionIndex++;
      }
    });
    setSlides(updatedSlides);
  };

  const toggleSelectAllCaptions = (selectAll) => {
    const updatedSlides = slides.map(slide => ({
      ...slide,
      applyCaption: selectAll
    }));
    setSlides(updatedSlides);

    // Update remaining lines count
    if (selectAll) {
      setRemainingLines(Math.max(captionLines.length - updatedSlides.length, 0));
    } else {
      setRemainingLines(captionLines.length);
    }
  };

  const handleDeleteAudio = async () => {
    if (!audioUrl) {
      alert("No audio to delete.");
      return;
    }
    if (!window.confirm("Delete current audio from this slideshow? This cannot be undone.")) return;
  
    try {
      setDeletingAudio(true);
      const storage = getStorage();
  
      // If we have a stored path, delete the storage object too.
      if (audioStoragePath) {
        const fileRef = ref(storage, audioStoragePath);
        await deleteObject(fileRef).catch((e) => {
          console.warn("Warning: couldn't delete storage object, continuing.", e);
        });
      }
  
      // Clear only the audio fields in the doc (no other changes)
      const showRef = doc(db, `slideshows/${slideshowId}`);
      await updateDoc(showRef, {
        audioUrl: "",
        audioStoragePath: ""
      });
  
      // Clear local UI state
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = "";
      }
      setAudioUrl(null);
      setAudioStoragePath(null);
      setNewAudioFile(null);
      setAudioDuration(0);
      setCurrentTime(0);
      alert("Audio removed.");
    } catch (err) {
      console.error("Error deleting audio:", err);
      alert("Failed to delete audio.");
    } finally {
      setDeletingAudio(false);
    }
  };
  
  const handleUploadAudio = async () => {
    if (!newAudioFile) {
      alert("Choose an audio file first.");
      return;
    }
    if (audioUrl) {
      alert("Audio already exists. Delete it first, then upload a new one.");
      return;
    }
  
    try {
      setUploadingAudio(true);
      const storage = getStorage();
      const safeId = encodeURIComponent(slideshowId);
      const audioRefStorage = ref(storage, `slideshows/${safeId}/music/${encodeURIComponent(newAudioFile.name)}`);
  
      await uploadBytes(audioRefStorage, newAudioFile);
      const url = await getDownloadURL(audioRefStorage);
  
      // Update only audio fields; leave everything else intact
      const showRef = doc(db, `slideshows/${slideshowId}`);
      await updateDoc(showRef, {
        audioUrl: url,
        audioStoragePath: audioRefStorage.fullPath
      });
  
      // Reflect in UI
      setAudioUrl(url);
      setAudioStoragePath(audioRefStorage.fullPath);
      if (audioRef.current) {
        audioRef.current.src = url;
        // Let metadata load naturally (you already listen for loadedmetadata)
      }
      setNewAudioFile(null);
      alert("Audio uploaded.");
    } catch (err) {
      console.error("Error uploading audio:", err);
      alert("Failed to upload audio.");
    } finally {
      setUploadingAudio(false);
    }
  };
  

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: 'auto' }}>
      <h2>Sync Editor for {slideshowId}</h2>

      {/* ---- Audio Controls ---- */}
<div style={{ marginTop: 12, padding: 12, border: '1px solid #ddd', borderRadius: 6 }}>
  <h3 style={{ marginTop: 0 }}>Audio</h3>

  {audioUrl ? (
    <>
      <div>
        <audio
          ref={audioRef}
          src={audioUrl}
          controls
          preload="auto"
          style={{ width: '100%' }}
        />
        <p>
          Current Time: {audioRef.current?.currentTime?.toFixed(3) ?? currentTime.toFixed(3)} / {audioDuration.toFixed(3)} seconds
        </p>
      </div>

      <button
        onClick={handleDeleteAudio}
        disabled={deletingAudio}
        style={{
          backgroundColor: '#f44336',
          color: 'white',
          padding: '8px 14px',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        {deletingAudio ? 'Deleting...' : 'Delete Audio'}
      </button>
    </>
  ) : (
    <>
      <input
        type="file"
        accept="audio/*"
        onChange={(e) => setNewAudioFile(e.target.files?.[0] ?? null)}
        style={{ display: 'block', marginBottom: 10 }}
      />
      <button
        onClick={handleUploadAudio}
        disabled={uploadingAudio || !newAudioFile}
        style={{
          backgroundColor: '#673ab7',
          color: 'white',
          padding: '8px 14px',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        {uploadingAudio ? 'Uploading...' : 'Upload Audio'}
      </button>
    </>
  )}
</div>

      <div style={{ marginTop: '20px' }}>
        {slides.map((slide, index) => (
          <div key={slide.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            {slide.type === 'video' ? (
              <video
                src={slide.imageUrl || slide.fileUrl || ''} // Use fallback logic
                width="100"
                height="auto"
                controls
                style={{ marginRight: '10px' }}
              />
            ) : (
              <img
                src={slide.imageUrl || slide.fileUrl || ''} // Use fallback logic
                alt={`Slide ${index + 1}`}
                style={{ width: '100px', height: 'auto', marginRight: '10px' }}
              />
            )}
            <div style={{ flex: 1 }}>
              <p><strong>Slide {index + 1}:</strong></p>
              <p><strong>File Name:</strong> {slide.fileName || 'Unknown'}</p>
              <p>
                Caption: <input
                  type="text"
                  value={slide.caption || ''}
                  onChange={(e) => {
                    const newSlides = [...slides];
                    newSlides[index].caption = e.target.value;
                    setSlides(newSlides);
                  }}
                  style={{ width: '100%' }}
                />
              </p>
              <p>
                Timestamp: <input
                  type="number"
                  step="0.01"
                  value={slide.timestamp !== undefined ? slide.timestamp : ''}
                  onChange={(e) => {
                    const newSlides = [...slides];
                    newSlides[index].timestamp = parseFloat(e.target.value);
                    setSlides(newSlides);
                  }}
                /> seconds
                <button onClick={() => setTimestampForSlide(index)} style={{ marginLeft: '10px' }}>Set to Current Time</button>
              </p>
              <label>
                <input
                  type="checkbox"
                  checked={!!slides[index].applyCaption}
                  onChange={(e) => {
                    const updated = [...slides];
                    const wasChecked = !!updated[index].applyCaption;
                    updated[index].applyCaption = e.target.checked;
                    setSlides(updated);

                    // Update remaining lines
                    if (e.target.checked && !wasChecked) {
                      setRemainingLines(prev => Math.max(prev - 1, 0));
                    } else if (!e.target.checked && wasChecked) {
                      setRemainingLines(prev => prev + 1);
                    }
                  }}
                /> Apply caption
              </label>
              <button
                onClick={() => handleDeleteSlide(slide.id)} // Add Delete button
                style={{
                  backgroundColor: '#f44336',
                  color: 'white',
                  padding: '6px 12px',
                  border: 'none',
                  borderRadius: '4px',
                  marginTop: '8px',
                  cursor: 'pointer'
                }}
              >
                Delete
              </button>
              <button
                onClick={() => handleDuplicateSlide(slide)}
                style={{
                  backgroundColor: '#ff9800',
                  color: 'white',
                  padding: '6px 12px',
                  border: 'none',
                  borderRadius: '4px',
                  marginTop: '8px',
                  marginLeft: '10px',
                  cursor: 'pointer'
                }}
              >
                Duplicate
              </button>
              <button
                onClick={() => {
                  const newSlides = [...slides];
                  const current = newSlides[index];
                  current.textPosition = current.textPosition === 'bottom' ? 'top' : 'bottom';
                  setSlides(newSlides);
                }}
                style={{
                  backgroundColor: '#3f51b5',
                  color: 'white',
                  padding: '6px 12px',
                  border: 'none',
                  borderRadius: '4px',
                  marginTop: '8px',
                  marginLeft: '10px',
                  cursor: 'pointer'
                }}
              >
                Toggle Text Position ({slide.textPosition === 'top' ? 'Top' : 'Bottom'})
              </button>
              <div style={{ display: 'flex', gap: '5px', marginTop: '8px' }}>
                <button
                  onClick={() => moveSlideUp(index)}
                  disabled={index === 0}
                  style={{
                    backgroundColor: '#607d8b',
                    color: 'white',
                    padding: '6px 12px',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  ↑ Move Up
                </button>
                <button
                  onClick={() => moveSlideDown(index)}
                  disabled={index === slides.length - 1}
                  style={{
                    backgroundColor: '#607d8b',
                    color: 'white',
                    padding: '6px 12px',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  ↓ Move Down
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={saveTimestamps}
        style={{
          backgroundColor: '#4CAF50',
          color: 'white',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          marginTop: '20px'
        }}
      >
        Save All Timestamps
      </button>

      <button
        onClick={saveCaptions}
        style={{
          backgroundColor: '#4CAF50',
          color: 'white',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          marginTop: '20px'
        }}
      >
        Save All Captions
      </button>

      <div style={{ marginTop: "20px" }}>
        <h3>Edit Logo and Text Options</h3>
        <div style={{ marginTop: "10px" }}>
          <label>
            Logo Size (%):
            <input
              type="number"
              value={logoSize}
              onChange={(e) => setLogoSize(parseInt(e.target.value) || 10)}
              style={{ marginLeft: "10px", width: "80px" }}
            />
          </label>
        </div>
        <div style={{ marginTop: "10px" }}>
          <label>
            Logo Position:
            <select
              value={logoPosition}
              onChange={(e) => setLogoPosition(e.target.value)}
              style={{ marginLeft: "10px" }}
            >
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
            </select>
          </label>
        </div>
        <div style={{ marginTop: "10px" }}>
          <label>
            Text Alignment:
            <select
              value={textAlignment}
              onChange={(e) => setTextAlignment(e.target.value)}
              style={{ marginLeft: "10px" }}
            >
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
            </select>
          </label>
        </div>
        <div style={{ marginTop: "10px" }}>
          <label>
            Text Size (px):
            <input
              type="number"
              value={textSize}
              onChange={(e) => setTextSize(parseInt(e.target.value) || 16)}
              style={{ marginLeft: "10px", width: "80px" }}
            />
          </label>
        </div>
        <div style={{ marginTop: "10px" }}>
          <label>
            <input
              type="checkbox"
              checked={textBackgroundEnabled}
              onChange={(e) => setTextBackgroundEnabled(e.target.checked)}
              style={{ marginRight: "10px" }}
            />
            Enable Text Background
          </label>
          {textBackgroundEnabled && (
            <>
              <input
                type="color"
                value={textBackgroundColor}
                onChange={(e) => setTextBackgroundColor(e.target.value)}
                style={{ marginLeft: "10px" }}
              />
              <div style={{ marginTop: "10px" }}>
                <label>
                  Background Opacity:
                  <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.1"
                    value={textBackgroundOpacity}
                    onChange={(e) => setTextBackgroundOpacity(parseFloat(e.target.value))}
                    style={{ marginLeft: "10px" }}
                  />
                  <span style={{ marginLeft: "10px" }}>{(textBackgroundOpacity * 100).toFixed(0)}%</span>
                </label>
              </div>
            </>
          )}
        </div>
        <div style={{ marginTop: "10px" }}>
          <label>
            Text Color:
            <input
              type="color"
              value={textColor}
              onChange={(e) => setTextColor(e.target.value)}
              style={{ marginLeft: "10px" }}
            />
          </label>
        </div>
        <div style={{ marginTop: "10px" }}>
          <label>
            Logo URL:
            <select
              value={newLogoUrl}
              onChange={(e) => setNewLogoUrl(e.target.value)}
              style={{ marginLeft: "10px", width: "100%" }}
            >
              {predefinedLogos.map((logo) => (
                <option key={logo.value} value={logo.value}>
                  {logo.label}
                </option>
              ))}
            </select>
          </label>
        </div>
        <button
          onClick={saveMetadata}
          style={{
            backgroundColor: '#4CAF50',
            color: 'white',
            padding: '10px 20px',
            marginTop: '20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          Save Changes
        </button>
      </div>

      <div style={{ marginTop: "30px" }}>
        <h3>Upload More Slides</h3>
        <input
          type="file"
          multiple
          accept="image/*"
          onChange={(e) => setNewSlides(Array.from(e.target.files))}
        />
        <button
          onClick={uploadNewSlides}
          disabled={newSlides.length === 0}
          style={{
            backgroundColor: '#673ab7',
            color: 'white',
            padding: '10px 20px',
            marginTop: '10px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          Upload New Slides
        </button>
      </div>

      <div style={{ marginTop: "30px" }}>
        <h3>Upload Captions</h3>
        <textarea
          rows="8"
          style={{ width: "100%" }}
          placeholder="Paste or type captions here, one line per slide"
          onChange={(e) => {
            const lines = e.target.value.split('\n').filter(line => line.trim() !== "");
            setCaptionLines(lines);
            setRemainingLines(lines.length - slides.filter(s => s.applyCaption).length);
          }}
        />
        <p><strong>Remaining lines:</strong> {remainingLines}</p>
        <div style={{ marginTop: '10px' }}>
          <button
            onClick={() => toggleSelectAllCaptions(true)}
            style={{
              backgroundColor: '#009688',
              color: 'white',
              padding: '6px 12px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              marginRight: '10px'
            }}
          >
            Select All
          </button>
          <button
            onClick={() => toggleSelectAllCaptions(false)}
            style={{
              backgroundColor: '#009688',
              color: 'white',
              padding: '6px 12px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Deselect All
          </button>
        </div>
        <button
          onClick={applyCaptionsAuto}
          disabled={captionLines.length === 0}
          style={{
            backgroundColor: '#4CAF50',
            color: 'white',
            padding: '10px 20px',
            marginTop: '10px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          Apply Captions to Slides (Auto)
        </button>
        <button
          onClick={applyCaptionsSelected}
          disabled={captionLines.length === 0}
          style={{
            backgroundColor: '#2196F3',
            color: 'white',
            padding: '10px 20px',
            marginTop: '10px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          Apply Captions to Selected Slides
        </button>
      </div>

      <div style={{ marginTop: '30px' }}></div>
        <button onClick={() => navigate(`/slideshow/${slideshowId}`)} style={navButtonStyle}>Go to SlideShow</button>
        <button onClick={() => navigate(`/slideuploader`)} style={navButtonStyle}>Go to SlideUploader</button>
      </div>

  );
};

export default SyncEditor;
